
































import { ButtonType } from '@getaccept/lib-ui';
import type { AxiosResponse } from 'axios';
import { defineComponent, ref } from '@vue/composition-api';
import { LoginService } from '../../api/login/login.service';
import i18n from '../../i18n/lang';

export default defineComponent({
  setup() {
    const loading = ref(false);
    const error = ref('');
    const domainName = ref('');

    const loginSso = async (domainName: string) => {
      loading.value = true;
      error.value = '';
      try {
        const redirectUrl = await LoginService.getSAMLUrl(domainName);

        if (redirectUrl) {
          window.open(redirectUrl, '_self');
          return;
        }
        loginSsoFailed();
      } catch ({ response }) {
        loginSsoFailed(response);
      }
    };

    const loginSsoFailed = (response?: AxiosResponse) => {
      loading.value = false;
      switch (response?.data?.error) {
        case 'Domain not found':
          error.value = i18n.t('domain-not-found').toString();
          break;
        case 'SAML configuration not found':
          error.value = i18n.t('saml-configuration-not-found').toString();
          break;
        default:
          error.value = i18n.t('something-went-wrong').toString();
      }
    };

    return {
      loading,
      error,
      ButtonType,
      loginSso,
      loginSsoFailed,
      domainName,
    };
  },
});
